export interface ApiResponse<T = unknown> {
  code: number
  extras?: string
  message: string
  result: T
  time?: string
  type?: string
}

export type RequestStatus = 'idle' | 'loading' | 'success' | 'error'

export interface PaginatedData<T> {
  list: T[]
  total: number
  page: number
  pageSize: number
}

export enum BizErrorCode {
  SUCCESS = 200,
  UNAUTHORIZED = 400,
  FORBIDDEN = 403,
  NOT_FOUND = 404,
  SERVER_ERROR = 500
}
